export const ConsoleCJ = {
  customError: (component: string, errors: unknown) => {
    console.error(`[${component}]`, errors);
  },

  log: (component: string, message: unknown) => {
    console.info(`[${component}]`, message);
  },

  warn: (component: string, message: unknown) => {
    console.warn(`[${component}]`, message);
  },
};
